import { ref, watch, nextTick } from 'vue';

export function useFormDataSync(getFormData, emit) {
    const localFormData = ref({ ...getFormData() });
    const updatingFromProp = ref(false);
    const updatingFromLocal = ref(false);

    watch(getFormData, (val) => {
        if (updatingFromLocal.value) return;
        updatingFromProp.value = true;
        localFormData.value = { ...val };
        nextTick(() => { updatingFromProp.value = false; });
    }, { deep: true });

    watch(localFormData, (val) => {
        if (updatingFromProp.value) return;
        updatingFromLocal.value = true;
        emit('update:usageFormData', { ...val });
        nextTick(() => { updatingFromLocal.value = false; });
    }, { deep: true });

    return { localFormData };
}
